<!--
 * @Descripttion: 个人中心-自助查询
 * @Author: liaoyijun
 * @Date: 2021-09-22 11:13:10
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-11 17:27:06
-->
<template>
    <div>
        <div class="ipservices-title">
            <div>
                <span>自助查询</span>
            </div>
        </div>
        <div class="ipservices-box">
            <div
                v-for="(item, index) in dataList"
                :key="index"
                class="ipservices-box-item"
                :class="['ipservices-box-item', { 'user-guide-resume-box': steps.step3 && index === 0 }]"
            >
                <div class="ipservices-box-top">
                    <div class="ipservices-box-top-img">
                        <img :src="item.url" alt="" />
                    </div>
                    <div>
                        <span>{{ item.info }}</span>
                    </div>
                </div>
                <div class="ipservices-box-middle">
                    <span>
                        {{ item.commond }}
                    </span>
                </div>
                <div class="ipservices-box-buttom">
                    <el-button plain size="mini" style="width:100%" @click="showDialog(item)">查看</el-button>
                </div>
            </div>
            <!-- <div class="ipservices-box-item">
                <img src="@/assets/pics/user-center/jqqd.png" alt="" /><span>更多功能 敬请期待</span>
            </div> -->
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "UserCenterInfo",
    data() {
        return {
            dataList: [
                {
                    info: "人才履历",
                    commond: "人才关键经历/成果、自我评价、社会职务填报",
                    url: require("@/assets/pics/user-center/rlnl.png"),
                },
                {
                    info: "个人信息",
                    commond: "个人信息一键全量查看和修改，全面呈现个人发展轨迹",
                    url: require("@/assets/pics/user-center/grxx.png"),
                },
                {
                    info: "我的薪资",
                    commond: "个人工资单查看和工资异常反馈",
                    url: require("@/assets/pics/user-center/wdxz.png"),
                },
                {
                    info: "我的合同",
                    commond: "个人劳动合同，服务协议档案查看",
                    url: require("@/assets/pics/user-center/wdht.png"),
                },
            ],
        };
    },
    computed: {
        ...mapState({
            steps: (state) => state.guide.userSteps,
        }),
    },
    methods: {
        showDialog(item) {
            if (["我的薪资", "个人信息"].includes(item.info)) {
                window.open(this.$config.hrUrl);
                return;
            }

            if (item.info === "人才履历") {
                const jumpUrl = this.$config.oaTalentUrl;
                this.handleRouterJump(2, jumpUrl, "", true);
                return;
            }
            this.$confirm("确定撤回此次预约?", "提示", {
                message: "该功能暂未上线，敬请期待~~",
                dangerouslyUseHTMLString: true,
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                showCancelButton: false,
                type: "warning",
            }).then((res) => {
                console.log(res);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.ipservices-title {
    height: 50px;
    border-bottom: 1px solid #d9d9d9;

    div {
        font-size: 16px;
        font-weight: 500;
        color: #666666;
        line-height: 22px;
        padding-top: 20px;
        padding-left: 20px;
    }
}
.ipservices-box {
    display: flex;
    justify-content: space-between;
    padding: 20px 30px 20px 30px;
    .ipservices-box-item {
        &.user-guide-resume-box {
            position: relative;
            z-index: 999;
            background-color: #fff;
            border-radius: 8px;
            border: 2px solid #3a9d80;
            pointer-events: none;
        }
        flex: 1;
        height: 218px;
        background: #f9f9f9;
        border-radius: 4px;
        padding: 27px 20px 27px 20px;
        margin-right: 20px;
        .ipservices-box-top {
            display: flex;
            font-size: 16px;
            font-weight: 400;
            color: #333333;
            margin-bottom: 16px;
            .ipservices-box-top-img {
                height: 24px;
                width: 22px;
                margin-right: 10px;
            }
        }
        .ipservices-box-middle {
            width: 100%;
            height: 60px;
            margin-bottom: 33px;
        }
        .ipservices-box-buttom {
            text-align: center;
            .el-button {
                color: #3a9d80;
            }
        }
        // &:last-child {
        //     display: flex;
        //     flex-direction: column;
        //     justify-content: center;
        //     align-items: center;
        //     img {
        //         width: 40px;
        //         height: 32px;
        //     }
        //     span {
        //         display: inline-block;
        //         width: 65px;
        //         text-align: center;
        //         font-size: 14px;
        //         font-family: PingFangSC-Regular, PingFang SC;
        //         font-weight: 400;
        //         color: #999999;
        //         margin-top: 12px;
        //     }
        // }
    }
}
</style>
